import {EventEmitter} from '@angular/core';
import {AbstractControlOptions} from '@angular/forms';

import {FormControlType} from '@sim/form';

export interface UIListFilters<T> {
  apply: EventEmitter<T>;
  data?: T;
  filters?: T;
}

/*@TODO number query operator???*/
export type StringQueryOperator =
  | 'equal'
  | 'not_equal'
  | 'greater'
  | 'less'
  | 'begins_with'
  | 'ends_with'
  | 'contains'
  | 'is_null'
  | 'range';

export type DateQueryOperator =
  | 'greater_or_equal'
  | 'less_or_equal';

export type RuleType = 'string' | 'date' | 'oid' | 'datetime' | 'double';

export interface QueryBuilderRule<T> {
  id?: string;
  field?: keyof T;
  operator?: StringQueryOperator | DateQueryOperator;
  value?: any;
  type?: RuleType;
  isMultiRange?: boolean;
}

export interface QueryBuilder<T> {
  condition?: 'OR' | 'AND';
  rules: (QueryBuilderRule<T> | QueryBuilder<T>)[];
}

export interface IFieldOptions<T> {
  value?: any,
  type?: FormControlType,
  controls?: FilterFieldsOptions<T>,
  operator: StringQueryOperator | DateQueryOperator,
  realField?: string,
  typeField?: RuleType,
  isRange?: boolean;
  isNullable?: boolean,
  isMinRange?: boolean;
  isMaxRange?: boolean;
  targetProp?: string;//nel caso di filtri in range il nome delle prop da filtrare differisce dal nome dell'input
};

export type FilterFieldsOptions<T> = { [P in keyof T]?: FilterFormOptions<T> };
export type FilterFormOptions<T> = AbstractControlOptions & IFieldOptions<T>


export function makeQueryBuilder<T>(rules: (QueryBuilderRule<T> | QueryBuilder<T>)[], condition: 'OR' | 'AND' = 'AND'): QueryBuilder<T> {
  return {condition, rules};
}

export function makeQueryRules<T, Z extends {
  [key: string]: any
}>(filters: T, meta: FilterFieldsOptions<T>): (QueryBuilderRule<Z> | QueryBuilder<Z>)[] {
  const builder: (QueryBuilderRule<Z> | QueryBuilder<Z>)[] = [];

  for (const property in filters) {
    if (meta[property] && (filters[property] || (meta[property] as FilterFormOptions<T>).isNullable)) {
      const fieldOptions = meta[property];

      const filterData = {
        field: (fieldOptions && fieldOptions.realField) || property,
        operator: fieldOptions && fieldOptions.operator,
        type: fieldOptions && fieldOptions.typeField,
        value: filters[property] || (meta[property] as FilterFormOptions<T>).value,
      }
      // if (fieldOptions?.isMinRange || fieldOptions?.isMaxRange || fieldOptions?.isRange) {
      //   filterData.field = fieldOptions.targetProp || filterData.field;
      //   if (filterData.value === null || filterData.value === undefined) continue;
      // }

      if (fieldOptions?.isRange) {

        if (filterData.value === null || filterData.value === undefined || filterData.value?.length == 0) continue;
        filterData.field = fieldOptions.targetProp || filterData.field;
        /*multi range select*/
        const subQueries = filterData.value.map((range: string) => {
          const split = range.split('-').map(parseFloat);
          const bottom = {...filterData, operator: 'greater', value: split[0], /*isMultiRange: true*/};
          if (split.length === 1) return bottom;
          const top = {...filterData, operator: 'less', value: split[1], /*isMultiRange: true*/};

          return {condition: 'AND', rules: [bottom, top]};
        })
        if (filterData.value.length > 1) {
          builder.push({condition: 'OR', rules: subQueries})
        } else {
          builder.push(...subQueries);
        }

      } else {
        builder.push(filterData);
      }
    }
  }

  return builder;
}



export const isQueryBuilderRule = <T>(rule: QueryBuilderRule<T> | QueryBuilder<T>): rule is QueryBuilderRule<T> => {
  return !Reflect.has(rule, 'condition');
}

export const isQueryBuilder = <T>(rule: QueryBuilderRule<T> | QueryBuilder<T>): rule is QueryBuilder<T> => {
  return Reflect.has(rule, 'condition');
}

export function extractFilterObjectFromParams<T>(_rules: (QueryBuilderRule<T> | QueryBuilder<T>)[], filterMeta: FilterFieldsOptions<T>) {

  const filters: T = {} as T;
  const rules = _rules.filter(isQueryBuilderRule).filter(r => !r.isMultiRange);
  const rangeRules = _rules.filter(isQueryBuilderRule).filter(r => r.isMultiRange);

  /*@TODO here rebuild filters for range!!!!!!!!!*/
  const params = rules.reduce((prev, curr) => {
    const key = curr.field;
    if (key) {
      prev[key] = curr.value;
    }
    return prev;
  }, {} as { [P in keyof T]: any });

  for (const property in filterMeta) {
    if (params[property]) {
      filters[property] = params[property];
    }
  }

  return filters;
}
